import './VoteLookup.css';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as actionCreators from '../../store/actions/actions'
import Helpers from '../../helpers/Helpers';
import Scorecard from '../../components/Scorecard/Scorecard';
import ScorecardPres from '../../components/ScorecardPres/ScorecardPres';
import ScorecardVicePres from '../../components/ScorecardVicePres/ScorecardVicePres';
import logo from '../../logo.png';
import ibewLogo from '../../ibewlogo.png';
import PropogateLoader from "react-spinners/PropagateLoader";
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import spacerBlank from '../../spacer_blank.gif';


class VoteLookup extends Component {

  state = {
    address: '', 
    errMess: '',
    officialDropDownList: [],
    selectedName: null,
    allOfficialsDlgOpen: false,
    scoreDlgMembers: [],
    scoreDlgOpen: false, 
    localUnionDlgLocal: null,
    localUnionDlgMembers: [], 
    localUnionDlgOpen: false
  }

  
  componentDidMount() {
    this.props.onGetCurrentMembersOfCongressDetailsLocal();
    //this.props.onGetCurrentMembersOfCongressDetails(1);
    //this.props.onGetCurrentMembersOfCongressDetails(2);
    //this.props.onGetCurrentMembersOfCongressDetails(3);
    this.props.onGetCurrentMembersOfCongress();
    this.props.onGetNewMembersOfCongress();
    this.props.onGetLocalCongressionalDistricts();
    this.props.onGetVoteRecords();
    this.props.onGetVoteRecordsAddendum();
    this.props.onGetVoteRecordsPn1789();
    this.props.onGetVoteRecordsBigBeautifulBill();
    this.props.onGetVoteRecordsBigBeautifulHouse2();
    this.props.onGetVoteRecordsFlexibility();
    this.props.onGetVoteRecordsPrudent();
  }

  handleChange=(e)=>{
    this.setState({address: e.target.value});
  }

  handleKeyPress=(e)=>{
    if (e.charCode==13){
      this.handleGo(e);
    }
  }

  handleClear=(e)=>{
    e.preventDefault();
    this.setState({address: ''});
    this.setState({errMess: ''});
    this.props.onClearSearchResults();
  }

  handleGo=(e)=>{
    e.preventDefault();
    //clear the last search first
    this.setState({errMess: ''});
    this.props.onClearSearchResults();
    let address = this.state.address;

    //if there is an at-large or at large in the address, change it to match our district convention (ie.SD-1)
    if (address.toUpperCase().indexOf("AT-LARGE")!=-1 || address.toUpperCase().indexOf("ATLARGE") !=-1 || address.toUpperCase().indexOf("AT LARGE") !=-1)
    {
      address = address.substring(0,2) + "-1";
    }

   
    //based on the value of address determine what type of search was executed
    if (address.length <6 && address.indexOf("-")>-1 && Helpers.isAlpha(address.substring(0,1)) && Helpers.isAlpha(address.substring(1,2)) && isFinite(address.substring(3,5))){
      if (address.slice(-1)=="-"){
        console.log('err.response', "error with the format of the district");
        this.setState({errMess: 'We had trouble with your the format of your district.  Please try again.'});
      }
      else
      {
        if(address.slice(-2,-1)==0){  //this is to remove a zero leading district number which caused issue in the searchDistrict routine
          address=address.replace("0","");
        }
        this.searchDistrict(address);
      }
    }
    else if (address.length < 19  && (address.toUpperCase().indexOf("LU")> -1 || address.toUpperCase().indexOf("LOCAL")>-1 || address.toUpperCase().indexOf("LOCAL UNION")>-1 || !isNaN(+address))){
        //have a value we believe was a local 
        //strip LU or Local to get an integer
        let local = Helpers.stripLocalFromAddress(address);
        //convert local to an int
        local = +local;        
        //now you can use this to do the local handle routine
        if (!isNaN(local)){
          this.searchLocal(local);
        }
        else
        {
          console.log('err.response', "error with the format of the local union");
          this.setState({errMess: 'We had trouble with your the format of your local union.  Please try again.'});
        }
    }
    else
    {
      //this is not a district or local search, attempt to search address
      this.searchAddress(address);
    } 
  }

  handleOpenAllOfficialsDlg=(e)=>{
    this.setState({allOfficialsDlgOpen: true});
  }

  handleCloseAllOfficialsDlg=(e)=>{
    this.setState({allOfficialsDlgOpen: false});
  }

  handleGoSelectedName=(e)=>{
    e.preventDefault();
    if(this.state.selectedName==null || Object.keys(this.state.selectedName).length===0){
      return;
    }
    else
    {
      const id=this.state.selectedName.id;
      const label=this.state.selectedName.label;
      let members=Helpers.getMembersFromDropDownList(id, label, this.props.currentMembersOfCongress);
      members=Helpers.updateMembersImageLink(members, this.props.currentMembersOfCongressDetails);
      members=Helpers.updateMemberVotes(members, this.props.voteRecords, this.props.newMembersOfCongress, this.props.voteRecordsAddendum, this.props.voteRecordsPn1789, this.props.voteRecordsBigBeautifulBill, this.props.voteRecordsBigBeautifulHouse2, this.props.voteRecordsFlexibility, this.props.voteRecordsPrudent);
      members=Helpers.replaceMemberExceptions(members);
      this.setState({scoreDlgMembers: members});
      this.setState({scoreDlgOpen: true});
     }
  }


  searchDistrict(address){
    //use the district info to determine the members and
    //load thier vote results
    this.props.onGetDistrictSearchResults(address, this.props.currentMembersOfCongress, this.props.currentMembersOfCongressDetails, this.props.voteRecords, this.props.newMembersOfCongress, this.props.voteRecordsAddendum, this.props.voteRecordsPn1789, this.props.voteRecordsBigBeautifulBill, this.props.voteRecordsBigBeautifulHouse2, this.props.voteRecordsFlexibility, this.props.voteRecordsPrudent);
  }

  searchLocal(local){
    //build the array of local union members and add it to the component state
    let localUnionMembers = Helpers.getMembersFromLocalUnionSearch(local, this.props.localCongressionalDistricts, this.props.currentMembersOfCongress);
    //add the votes
    localUnionMembers=Helpers.updateMemberVotes(localUnionMembers, this.props.voteRecords, this.props.newMembersOfCongress, this.props.voteRecordsAddendum, this.props.voteRecordsPn1789, this.props.voteRecordsBigBeautifulBill, this.props.voteRecordsBigBeautifulHouse2, this.props.voteRecordsFlexibility, this.props.voteRecordsPrudent);
    this.setState({localUnionDlgLocal: local});
    this.setState({localUnionDlgMembers: localUnionMembers});
    this.setState({localUnionDlgOpen: true});
  }

  searchAddress(address){
    this.props.onGetAddressSearchResults(address, this.props.currentMembersOfCongress, this.props.currentMembersOfCongressDetails, this.props.voteRecords, this.props.newMembersOfCongress, this.props.voteRecordsAddendum, this.props.voteRecordsPn1789, this.props.voteRecordsBigBeautifulBill,this.props.voteRecordsBigBeautifulHouse2, this.props.voteRecordsFlexibility, this.props.voteRecordsPrudent);
  }

  handleCloseScoreDlg=(e)=>{
    e.preventDefault();
    this.setState({scoreDlgMembers: []});
    this.setState({scoreDlgOpen: false});
  }

  handleCloseLocalUnionDlg=(e)=>{
    e.preventDefault();
    this.setState({address: ''});
    this.setState({localUnionDlgLocal: null});
    this.setState({localUnionDlgMembers: []});
    this.setState({localUnionDlgOpen: false});
  }

  transformLocalUnionMembers=(members)=>{
    console.log(members);
    let i=0;
    const tranformedMembers = members.map(mem=>{
      i+=1;
      if (mem.state.toUpperCase()=="OH" && mem.district==6){
        //for oh-6 vacancy
        return <tr key={i}><td>Vacant</td>
        <td>{mem.state.toUpperCase() + " " + mem.district}</td><td>na</td><td>na</td>
        <td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td></tr>
      }
      else if (mem.state.toUpperCase()=="NY" && mem.district==26){
        return <tr key={i}><td>Rep. Tim Kennedy</td>
        <td>NY 26</td><td>Democratic</td><td>Score: 89%</td>
        <td>With IBEW</td><td>With IBEW</td><td>With IBEW</td><td>With IBEW</td><td>*Absent</td><td>N/A</td><td>With IBEW</td><td>With IBEW</td><td>With IBEW</td><td>With IBEW</td></tr>
      }
      else
      {
        return <tr key={i}><td>{mem.memShortTitle + ". " + mem.first_name + " " + mem.last_name}</td>
          <td>{mem.state.toUpperCase() + " " + mem.district}</td><td>{mem.party}</td><td>{mem.memGrade}</td>
          <td>{Helpers.transformOneVote(mem.vote1,mem,0)}</td><td>{Helpers.transformOneVote(mem.vote2,mem,0)}</td>
          <td>{Helpers.transformOneVote(mem.vote3,mem,0)}</td><td>{Helpers.transformOneVote(mem.vote4,mem,0)}</td>
          <td>{Helpers.transformOneVote(mem.vote5,mem,0)}</td><td>{Helpers.transformOneVote(mem.vote6,mem,1)}</td>
          <td>{Helpers.transformOneVote(mem.vote7,mem,0)}</td><td>{Helpers.transformOneVote(mem.vote8,mem,2)}</td>
          <td>{Helpers.transformOneVote(mem.vote9,mem,2)}</td><td>{Helpers.transformOneVote(mem.vote10,mem,2)}</td>
          </tr>
      }
    });
    return tranformedMembers;
  }

  transformAllOfficials=(officials)=>{
    let i=0;
    const transformedOfficials = officials.map(official=>{
      i+=1
      return <tr key={i}><td>{official.office}</td><td>{official.name}</td><td>{official.party}</td></tr>
    });
    return transformedOfficials;
  }


  render (){
    return <div className="App">
      <div className="w3-container header-top">
        <div className="w3-row">&nbsp;</div>
        <div className="w3-row">
          <div className="w3-half"><img src={logo} width="100%"></img></div>
          <div className="w3-half">
            <div className="title-font">IBEW Legislative Scorecard</div>
            <div className="title-sub-font">How your legislators voted on key IBEW bills</div>
          </div>
        </div>
        <div className="w3-row">
          <div>
            Find Your Elected Officials:<br />
            <div><input id="address" autoFocus type="text" value={this.state.address} onChange={this.handleChange} onKeyPress={this.handleKeyPress} placeholder="Address, State-District (eg. VA-11) or IBEW Local..."></input>&nbsp; {this.props.currentMembersOfCongressDetails.length>500?<span><button onClick={this.handleGo}>Search</button></span>:null}&nbsp;
            {this.props.searchResultMembers.length>0 || this.state.errMess || this.props.actionErrorMessage ? <span><button onClick={this.handleClear}>Reset</button></span> :null}
              &nbsp;{this.props.searchResultMembers.length>0 && this.props.addressSearchResults && this.props.addressSearchResults.normalizedInput.zip.length>0 && this.props.searchResultOfficials.length>0? <span><button onClick={this.handleOpenAllOfficialsDlg}>List of Elected Officials</button></span> :null}
            </div>
            <span id='localInfo' className="small-local-instruction">"IBEW Local" search is limited to IBEW Inside Construction Local Unions.</span>
            <span id='err' className="small-err"><br/>{this.state.errMess}{this.props.actionErrorMessage}</span>
          </div>
        </div>
      </div>
      <div className="w3-container gold-row"><img src={ibewLogo} className={'ibew-logo'}/></div>
      {this.props.searchResultMembers.length>0? 
      <div>
        {/*<div className="w3-row-padding">
          <div className="w3-half result-container">
            <ScorecardPres  
                member={this.props.searchResultMembers[0]}
              ></ScorecardPres>
          </div>
          <div className="w3-half result-container">
            <ScorecardVicePres
              member={this.props.searchResultMembers[1]}
            ></ScorecardVicePres>
          </div>
        </div>*/}
        <div className="w3-row-padding">
            <div className="w3-third result-container">
              <Scorecard  
                  member={this.props.searchResultMembers[2]}
                ></Scorecard>
            </div>
            <div className="w3-third result-container">
              <Scorecard  
                member={this.props.searchResultMembers[3]}
              ></Scorecard>
            </div>
            <div className="w3-third result-container">
              <Scorecard  
                member={this.props.searchResultMembers[4]}
              ></Scorecard>
            </div>
          </div>
        </div> : !this.props.searchResultMembers.length>0 ? <div>
        <div className="w3-row app-instructions">
            <p>
              Please enter your address above to view how the elected officials from your district and state voted on 
              legislation that is important to IBEW members.</p>
              <table><tbody>
              <tr><td style={{ width: 295 }}><Autocomplete
                disablePortal
                id="ddlOfficial"
                options={this.props.membersOfCongressDropDownList}
                sx={{ width: 295 }}
                renderInput={(params) => <TextField {...params} label="Official" />}
                onChange={(event, newValue) => {
                  this.setState({selectedName: newValue});
                }}
              /></td></tr><tr>
                  <td style={{ verticalAlign: 'middle' }}>{this.props.currentMembersOfCongressDetails.length>500?<span><button onClick={this.handleGoSelectedName}>Get Scorecard</button></span>:null}
                </td></tr>
              </tbody></table>
              <p>You may also view the scorecard for a specific official with the dropdown selector above.</p>
        </div>
      </div> : <div><div className="w3-row app-instructions"></div>
              <div className="spinner-div"><PropogateLoader
                color="#536399"
                loading={this.state.errMess.length==0}
                size={20}
                speedMultiplier="1"
              /></div> 
      </div>}
      <div className="w3-container bottom-row"><div className="bottom-attribution"> Contact the IBEW Government Affairs Department at <a href="mailto:GovernmentAffairs@ibew.org">GovernmentAffairs@ibew.org</a> for further information about these and other votes. Powered by the <a target="_blank" href='https://developers.google.com/civic-information/'>Google Civic Information API</a></div></div>
      <br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br />
      <div className="attribution-mobile">
        <div>Contact the IBEW Government Affairs Department at <a href="mailto:GovernmentAffairs@ibew.org">GovernmentAffairs@ibew.org</a> for further information about these and other votes.</div>
        <div>Powered by the <a target="_blank" href='https://developers.google.com/civic-information/'>Google Civic Information API</a></div>
      </div> 
      <Dialog
            open={this.state.allOfficialsDlgOpen}
            onClose={this.handleCloseAllOfficialsDlg}
            fullWidth={true}
            maxWidth={'md'}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            >
            <DialogTitle id="alert-dialog-title">
              <b>Elected Officials for: {this.props.searchResultNormalizedAddress}</b>
            </DialogTitle>
            <DialogContent dividers>
              <table className="minimalistBlack">
                <thead>
                  <tr>
                    <th>Office</th>
                    <th>Official</th>
                    <th>Party</th>
                  </tr>
                </thead>
                <tbody>
                  { this.props.searchResultOfficials.length>0?
                    this.transformAllOfficials(this.props.searchResultOfficials): ""
                  }
                </tbody>
              </table>
            </DialogContent>
            <DialogActions>
              <Button onClick={this.handleCloseAllOfficialsDlg}>
                Close
              </Button>
            </DialogActions>
      </Dialog>
      <Dialog
            open={this.state.scoreDlgOpen}
            onClose={this.handleCloseScoreDlg}
            fullWidth={true}
            maxWidth={'md'}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            >
            <DialogTitle id="alert-dialog-title">
              <b>Legislator Scorecard for: {this.state.scoreDlgMembers.length>0 ? this.state.scoreDlgMembers[0].memName + " " + this.state.scoreDlgMembers[0].memNameSub  : ""}</b>
            </DialogTitle>
            <DialogContent dividers>
                <div style={{display: 'flex',  justifyContent:'center', alignItems:'center'}}>
                { this.state.scoreDlgMembers.length>0 ? 
                    <Scorecard  
                      member={this.state.scoreDlgMembers[0]}
                      ></Scorecard> : 
                    <div className="spinner-div"><PropogateLoader
                        color="#536399"
                        loading={this.state.scoreDlgMembers.length==0}
                        size={20}
                        speedMultiplier="1"
                    /></div> 
                  }
                </div>
            </DialogContent>
            <DialogActions>
              <Button onClick={this.handleCloseScoreDlg}>
                Close
              </Button>
            </DialogActions>
      </Dialog>
      <Dialog
            open={this.state.localUnionDlgOpen}
            onClose={this.handleCloseLocalUnionDlg}
            fullWidth={true}
            maxWidth={'lg'}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            >
            <DialogTitle id="alert-dialog-title">
              <b>Elected Officials for Local Union: {this.state.localUnionDlgLocal}</b>
            </DialogTitle>
            <DialogContent dividers>
                <div style={{display: 'flex',  justifyContent:'center', alignItems:'center'}}>
                {this.state.localUnionDlgMembers.length==0?<b>The Local Union: {this.state.localUnionDlgLocal} is not classified as an IBEW Inside Construction Local.  It is not available for the Local Union search right now.  In the meantime, you can use the address and district searches to find scorecards for your Members of Congress.</b>:
                <table className="minimalistBlack">
                  <thead>
                    <tr>
                      <th>Member of Congress</th>
                      <th>State/Dist</th>
                      <th>Party</th>
                      <th>Score</th>
                      <th>IIJA</th>
                      <th>Inflation</th>
                      <th>CHIPS</th>
                      <th>Fiscal</th>
                      <th>Appropriations</th>
                      <th>Confirmation</th>
                      <th>2025 Budget</th>
                      <th>2025 Budget Final</th>
                      <th>Flexibility</th>
                      <th>Prudent</th>
                    </tr>
                  </thead>
                  <tbody>
                  { 
                  this.state.localUnionDlgMembers.length>0?
                    this.transformLocalUnionMembers(this.state.localUnionDlgMembers):""
                  }
                  </tbody>
                </table>}
                </div>
            </DialogContent>
            <DialogActions>
              <Button onClick={this.handleCloseLocalUnionDlg}>
                Close
              </Button>
            </DialogActions>
      </Dialog>
    </div>
  }
}


const mapStateToProps = (state) =>{
  return {
      voteRecords: state.voteRecords,
      voteRecordsAddendum: state.voteRecordsAddendum,
      voteRecordsPn1789: state.voteRecordsPn1789,
      voteRecordsBigBeautifulBill: state.voteRecordsBigBeautifulBill,
      voteRecordsBigBeautifulHouse2: state.voteRecordsBigBeautifulHouse2,
      voteRecordsFlexibility: state.voteRecordsFlexibility,
      voteRecordsPrudent: state.voteRecordsPrudent,
      currentMembersOfCongress: state.currentMembersOfCongress,
      currentMembersOfCongressDetails: state.currentMembersOfCongressDetails,
      newMembersOfCongress: state.newMembersOfCongress,
      localCongressionalDistricts: state.localCongressionalDistricts,
      addressSearchResults: state.addressSearchResults,
      searchResultMembers: state.searchResultMembers,
      searchResultNormalizedAddress: state.searchResultNormalizedAddress,
      searchResultOfficials: state.searchResultOfficials,
      membersOfCongressDropDownList: state.membersOfCongressDropDownList,
      actionErrorMessage: state.actionErrorMessage
  }
};

const mapDispatchToProps = dispatch =>{
  return {
      onGetVoteRecords: () => dispatch(actionCreators.voteRecordsGet()),
      onGetVoteRecordsAddendum: () => dispatch(actionCreators.voteRecordsAddendumGet()),
      onGetVoteRecordsPn1789: () => dispatch(actionCreators.voteRecordsPn1789Get()),
      onGetVoteRecordsBigBeautifulBill: () => dispatch(actionCreators.voteRecordsBigBeautifulBillGet()),
      onGetVoteRecordsBigBeautifulHouse2: () => dispatch(actionCreators.voteRecordsBigBeautifulHouse2Get()),
      onGetVoteRecordsFlexibility: () => dispatch(actionCreators.voteRecordsFlexibilityGet()),
      onGetVoteRecordsPrudent: () => dispatch(actionCreators.voteRecordsPrudentGet()),
      onGetCurrentMembersOfCongress: () => dispatch(actionCreators.currentMembersOfCongressGet()),
      onGetCurrentMembersOfCongressDetails: (group) => dispatch(actionCreators.currentMembersOfCongressDetailsGet(group)),
      onGetCurrentMembersOfCongressDetailsLocal: () => dispatch(actionCreators.currentMembersOfCongressDetailsLocalGet()),
      onGetNewMembersOfCongress: () => dispatch(actionCreators.newMembersOfCongressGet()),
      onGetLocalCongressionalDistricts: () => dispatch(actionCreators.localCongressionalDistrictsGet()),
      onGetAddressSearchResults: (address, currentMembersOfCongress, currentMembersOfCongressDetails, voteRecords, newMembersOfCongress, voteRecordsAddendum, voteRecordsPn1789, voteRecordsBigBeautifulBill, voteRecordsBigBeautifulHouse2, voteRecordsFlexibility, voteRecordsPrudent) => dispatch(actionCreators.addressSearchResultsGet(address, currentMembersOfCongress, currentMembersOfCongressDetails, voteRecords, newMembersOfCongress, voteRecordsAddendum, voteRecordsPn1789, voteRecordsBigBeautifulBill, voteRecordsBigBeautifulHouse2, voteRecordsFlexibility, voteRecordsPrudent)),
      onGetDistrictSearchResults: (address, currentMembersOfCongress, currentMembersOfCongressDetails, voteRecords, newMembersOfCongress, voteRecordsAddendum, voteRecordsPn1789, voteRecordsBigBeautifulBill, voteRecordsBigBeautifulHouse2, voteRecordsFlexibility, voteRecordsPrudent) => dispatch(actionCreators.districtSearchResultsGet(address, currentMembersOfCongress, currentMembersOfCongressDetails, voteRecords, newMembersOfCongress, voteRecordsAddendum, voteRecordsPn1789, voteRecordsBigBeautifulBill, voteRecordsBigBeautifulHouse2, voteRecordsFlexibility, voteRecordsPrudent)),
      onClearSearchResults: () => dispatch(actionCreators.searchResultsClear())
  }
};

export default connect(mapStateToProps, mapDispatchToProps) (VoteLookup);;

